/**
 * Created by ys on 2018/5/29.
 */
import Cookies from 'js-cookie';
let routers = localStorage.getItem("routers");
const sys = {
  state: {
    sidebar: !+Cookies.get('sidebarStat'),
    routers:routers != null && routers!= undefined && routers != "" ? JSON.parse(routers) :[],//管理界面的路由
    menuTheme: 'dark',
    currentPathArr: [],
    pageOpenedList: [{
      name: "home_index",
      path: "/main",
      title: "首页"
    }],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.routers = routers;

      localStorage.setItem("routers", JSON.stringify(routers));
    },
    SET_SIDEBAR: state => {
      if (state.sidebar) {
       Cookies.set('sidebarStat', 1);
      } else {
        Cookies.set('sidebarStat', 0);
      }
      state.sidebar = !state.sidebar
    },
    CLOSE_SIDEBAR: state => {
      Cookies.set('sidebarStat', 0);
      state.sidebar = true
    },
    SET_currentPathArr: (state, currentPathArr) => {
      state.currentPathArr = currentPathArr
    },
    addPageOpened: (state, tag) => {
      let flag = true;
      state.pageOpenedList.map((item, index) => {
        if (item.name === tag.name) {
          flag = false;
        }
      });
      if (flag) {
        state.pageOpenedList.push(tag);
      }
      if (state.pageOpenedList.length > 8) {
        state.pageOpenedList.splice(1, 1);
      }
    },
    closeOnePageOpend: (state, name) => {
      state.pageOpenedList.map((item, index) => {
        if (item.name === name) {
          state.pageOpenedList.splice(index, 1);
        }
      });
    },
    clearAllPageTags: (state) => {
      state.pageOpenedList = [{
        name: "home_index",
        path: "/main",
        title: "首页"
      }];
    },
    clearOtherPageTags: (state, name) => {
      let newPageList = [];
      state.pageOpenedList.map((item, index) => {
        if (item.name === name || item.name === "home_index") {
          newPageList.push(item)
        }
      });
      state.pageOpenedList = newPageList;
    },
    ChangeMenuTheme:(state, name) => {
      if(state.menuTheme==='dark'){
        state.menuTheme = 'light';
      }else{
        state.menuTheme = 'dark';
      }
    }
  },
  actions: {
    ChangeSidebar: ({commit}) => {
      commit('SET_SIDEBAR')
    },
    GenerateRoutes({commit}, data){
      return new Promise(resolve => {
        commit('SET_ROUTERS', data);
        resolve();
      })
    },
    ChangeCurrentPathArr({commit}, data){
      commit('SET_currentPathArr', data);
    },
    closeSidebar: ({commit}) => {
      commit('CLOSE_SIDEBAR')
    },
  }
};
export default sys;



// WEBPACK FOOTER //
// ./src/store/modules/sys.js